import { useCallback } from "react";
import { RootState } from "../store";
import * as CertameActions from "../store/Certame.reducer";
import { useAppDispatch, useAppSelector } from "./hooks";

export default function useCertame() {
  const dispatch = useAppDispatch();

  const certame = useAppSelector((state: RootState) => state.certame.certame);

  const certames = useAppSelector((state: RootState) => state.certame.list);

  const fetching = useAppSelector((state: RootState) => state.certame.fetching);

  const getCertames = useCallback(() => {
    dispatch(CertameActions.getCertames());
  }, [dispatch]);

  return {
    certame,
    certames,
    getCertames,
    fetching,
  };
}
